import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
// core
import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Toolbar,
} from '@material-ui/core';
// icons
import Button from '../../../components/Button';
import Modal from '../../../components/Modal';
import TicketForm from './ticketForm';

import useStyles from './styles';

// Filters area, table header
export default function TableToolbar({
  setFilterOptions, sendResponse,
}) {
  const styles = useStyles();
  const { t } = useTranslation();
  const [openCreateTicket, setOpenCreateTicket] = useState(false);
  const [tab, setTab] = useState('clear');

  const handleCreateTicket = () => {
    setOpenCreateTicket(true);
  };

  const handleSelectFilter = (event) => {
    const id = event.target.value;
    let column = 'state';
    let searchValue;

    if (id === 'clear') {
      searchValue = '';
      column = false;
    } else {
      searchValue = id;
      column = 'state';
    }

    setFilterOptions(searchValue, column);
    setTab(id);
  };

  return (
    <>
      <Toolbar className={styles.toolbarTable}>
        <FormControl className={styles.formControl}>
          <InputLabel id="demo-simple-select-label">{t('support.columnNames.status')}</InputLabel>
          <Select
            value={tab}
            onChange={handleSelectFilter}
            className={styles.toolSelect}
          >
            <MenuItem value="clear" selected={true}>{t('support.all')}</MenuItem>
            <MenuItem value="open">{t('support.open')}</MenuItem>
            <MenuItem value="evaluation">{t('support.evaluation')}</MenuItem>
            <MenuItem value="quoted">{t('support.quoted')}</MenuItem>
            <MenuItem value="approved">{t('support.approved')}</MenuItem>
            <MenuItem value="processing">{t('support.processing')}</MenuItem>
            <MenuItem value="objected">{t('support.objected')}</MenuItem>
            <MenuItem value="adjust">{t('support.adjust')}</MenuItem>
            <MenuItem value="rejected">{t('support.rejected')}</MenuItem>
            <MenuItem value="finished">{t('support.finished')}</MenuItem>
            <MenuItem value="close">{t('support.close')}</MenuItem>
          </Select>
        </FormControl>
        <Button
          id="create-user-btn"
          text={'+ Ticket'}
          variant="contained"
          height="40px"
          width="130px"
          backgroundColor='theme-custom-solidButtonBackground'
          color='theme-custom-solidButtonText'
          borderRadius='10px'
          onClick={handleCreateTicket}
        />
      </Toolbar>
      {openCreateTicket ? (
        <Modal title={t('support.ticketForm.modalTitle')} defaultOpen={openCreateTicket} setCurrentOpen={setOpenCreateTicket}>
          <TicketForm sendResponse={sendResponse} setCurrentOpen={setOpenCreateTicket} />
        </Modal>
      ) : null}
    </>
  );
}
